import { runSyncOk } from './exec';

const availableDisplays = [
  runSyncOk('chromium', ['--version']) && 'chromium',
  runSyncOk('firefox', ['--version']) && 'firefox',
  // runSyncOk('livestreamer', ['--version']) && 'livestreamer', TODO checked dailymotion and Twitch, failed because json parsing or auth
  runSyncOk('omxplayer', ['--version']) && 'omxplayer',
].filter(Boolean);

export const webBrowsers = ['chromium', 'firefox'];

export const availableWebBrowsers = availableDisplays.filter(display =>
  webBrowsers.includes(display),
);

export default availableDisplays;
